import React from 'react';

import NextImage from 'next/image';

import { CATCH_MAP_HEIGHT, CATCH_MAP_WIDTH } from '../../../constants/constants';
import { GetPost_entry_catch_fishingWater } from '../../../interfaces/graphql';
import { getSecretStaticWaterMap } from '../../Maps/mapData/staticMaps';
import { StaticMapPlaceholder } from '../../Placeholder/StaticMapPlaceholder';
import { MapboxAttribution } from '../../MapboxAttribution/MapboxAttribution';

interface ISecretWaterMapProps {
  waterDetails?: GetPost_entry_catch_fishingWater;
}

export const SecretWaterMap = ({ waterDetails }: ISecretWaterMapProps) => {
  if (!waterDetails?._id) {
    return <></>;
  }

  const { longitude, latitude } = waterDetails;

  return (
    <div className="relative h-64 w-full">
      <StaticMapPlaceholder />
      <NextImage
        alt="Water map"
        data-testid="SecretWaterMap"
        className="absolute top-0 left-0 size-full"
        src={getSecretStaticWaterMap(
          longitude.toString(),
          latitude.toString(),
          CATCH_MAP_WIDTH,
          CATCH_MAP_HEIGHT,
          'satellite',
        )}
        width={CATCH_MAP_WIDTH}
        height={CATCH_MAP_HEIGHT}
        unoptimized
      />
      <MapboxAttribution isLinked={false} />
    </div>
  );
};
